import React, { useCallback, useEffect, useRef, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { ButtonBack, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import FilterSelect from '../../../components/select/filterSelect';
import { Box, IconButton, MenuItem } from '@mui/material';
import InputTextField from '../../../components/input/inputTextField';
import { SearchOutlined } from '@mui/icons-material';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateTimeToView } from '../../../utils/date.utils';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { routeName } from '../../../routes/routeName';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useDispatch } from 'react-redux';
import { CourseAnnualApi } from '../../../api/course-annual/course-annual.api';
import { swalError, swalSuccess } from '../../../components/alert/swal';
import ModalCustom from '../../../components/modal/ModalCustom';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as Icon_upload } from '../../../assets/icons/Upload_signature.svg'
import { useTranslation } from 'react-i18next';
import ContainerButton from '../../../components/button/ContainerButton';
import { MyCourseOfStudyApi } from '../../../api/my-course-of-study/my-course-of-study.api';
import { getFileExtension } from '../../../utils/fileTypeDownload';
import saveAs from 'file-saver';
const days: any[] = [
    'ทุกวัน', // i18n-ignore: day option label, rendered with t
    "อาทิตย์", // i18n-ignore: day option label, rendered with t
    "จันทร์", // i18n-ignore: day option label, rendered with t
    "อังคาร", // i18n-ignore: day option label, rendered with t
    "พุธ", // i18n-ignore: day option label, rendered with t
    "พฤหัสบดี", // i18n-ignore: day option label, rendered with t
    "ศุกร์", // i18n-ignore: day option label, rendered with t
    "เสาร์", // i18n-ignore: day option label, rendered with t
];
export default function CourseOfStudyTable(props: any) {
    const { academic_year, term, status_publish, detail, course_annual_file, getDetail } = props
    const { id } = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const [data, setData] = useState<any[]>([]);
    const [open, setOpen] = useState<boolean>(false);
    const [file, setFile] = useState<any>();
    const fileInputRef = useRef<HTMLInputElement>(null);

    const [type, setType] = useState<string>("NEW");
    const [keyword, setKeyword] = useState<string>("");
    const [room, setRoom] = useState<string>("ทุกห้อง"); // i18n-ignore: room filter sentinel value, rendered with t
    const [pathUrl, setPathUrl] = useState<string>("");

    const [study_day, set_study_day] = useState<any>('0');
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleImageUploadClick = () => {
        fileInputRef.current?.click();
    };
    const updateImage = (event: any) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            setFile(file);
        }
    };
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [
        {
            id: "#",
            width: '300px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("COUNRSE_OF_STUDT.COURSE_NAME"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("COUNRSE_OF_STUDT.COURSE_CODE"),
        },
        // {
        //     id: "leave_type_name",
        //     width: '100px',
        //     sortable: false,
        //     disablePadding: false,
        //     align: "center",
        //     label: t("COUNRSE_OF_STUDT.DAY"),
        // },
        {
            id: "status",
            disablePadding: false,
            width: '100px',
            sortable: false,
            align: "center",
            label: t("COUNRSE_OF_STUDT.CREDIT"),
        },
        {
            id: "status",
            disablePadding: false,
            width: '100px',
            sortable: false,
            align: "center",
            label: t("COUNRSE_OF_STUDT.ROOM"),
        },
        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("COUNRSE_OF_STUDT.LAST_UPDATED_BY"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("COUNRSE_OF_STUDT.LAST_UPDATED_DATE"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            room,
            courses_name,
            courses_no,
            credits,
            id_course_annual,
            modified_name,
            create_name,
            created_date,
            modified_date
        } = objData;

        const objRenderData = {
            key: id_course_annual,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: courses_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: courses_no,
                },

                // {
                //     option: "TEXT",
                //     align: "center",
                //     label: (
                //         ''
                //     ),
                // },
                {
                    option: "TEXT",
                    align: "center",
                    label: credits,
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        room || ''
                    ),
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modified_name || create_name || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : dateTimeToView(created_date),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableCopy={status_publish !== 'PUBLISH'}
                            enableEdit={status_publish !== 'PUBLISH'}
                            enableDelete={status_publish !== 'PUBLISH'}
                            onViewClick={() => {
                                navigate(
                                    routeName.cms.CourseOfStudySubjectDetail.replace(':id', id || '').replace(':idDetail', id_course_annual) + '?academic_year=' + academic_year + `&term=${term}` + '&mode=VIEW'
                                );
                            }}
                            onCopy={() => {
                                navigate(
                                    routeName.cms.CourseOfStudySubjectDetail.replace(':id', id || '').replace(':idDetail', id_course_annual) + '?academic_year=' + academic_year + `&term=${term}` + '&mode=COPY'
                                );
                            }}
                            onEditClick={() => {
                                navigate(
                                    routeName.cms.CourseOfStudySubjectDetail.replace(':id', id || '').replace(':idDetail', id_course_annual) + '?academic_year=' + academic_year + `&term=${term}`
                                );
                            }}
                            onDeleteClick={() => {

                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {
                id_course_of_study: id
            };
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (academic_year) condition = { ...condition, academic_year: academic_year };
            if (term) condition = { ...condition, term: term };
            if (keyword) condition = { ...condition, keyword: keyword };
            if (study_day != '0') condition = { ...condition, study_day: +study_day - 1 };
            if (room != 'ทุกห้อง') condition = { ...condition, room: room }; // i18n-ignore: room filter sentinel value, rendered with t

            const res = await CourseAnnualApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data?.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, academic_year, keyword,term, study_day, room]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const getFile = async (id_course_annual_file: any) => {
        const res = await CourseAnnualApi.getFile(id_course_annual_file);
        const data = res.data;
        const response = res.data;

        // Get the content type from the server's response headers
        const contentType = res.headers["content-type"];

        // Create a Blob with the content type from the response
        const blob = new Blob([response], { type: contentType });

        setPathUrl(URL.createObjectURL(blob))
        // // Extract file extension based on content type
        // const fileExtension = getFileExtension(contentType || "");

        // // Generate a filename with the correct extension (you can also modify this to use a custom name)
        // const fileName = `${"report-advisor" + new Date().getTime()
        //     }.${fileExtension}`;

        // // Save the file
        // saveAs(blob, fileName);
    }
    // useEffect(() => {
    //     const init = async () => {
    //         const response = await fetch("/resources/config.json");
    //         const results = await response.json();
    //         setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
    //     };
    //     init();
    //     if (course_annual_file) {
    //         setType('')
    //     }
    // }, []);
    const handleUpdateStatus = async (status: string) => {

        const formData = new FormData();
        formData.append('id_course_of_study', id || '');
        formData.append('academic_year', academic_year || '');
        formData.append('status_publish', status)
        //DRAFT
        formData.append('file', file);
        await CourseAnnualApi.publish(formData).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('COUNRSE_OF_STUDT.PUBLISH_SUCCESS'))
                loadData()
                getDetail()
                handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })

    }
    const handleClose = async () => {
        setOpen(false)
        setFile(null)
    }
       const handleDownloadFile = async () => {
    
            dispatch(setLoading());
    
            await MyCourseOfStudyApi.download_teacher(id, term)
                .then((res) => {
                    if (res.status < 300) {
                        const response = res.data;
    
                        // Get the content type from the server's response headers
                        const contentType = res.headers["content-type"];
    
                        // Create a Blob with the content type from the response
                        const blob = new Blob([response], { type: contentType });
    
                        // Extract file extension based on content type
                        const fileExtension = getFileExtension(contentType || "");
    
                        // Generate a filename with the correct extension (you can also modify this to use a custom name)
                        const fileName = `${"my-course-of-study-teacher" + new Date().getTime()
                            }.${fileExtension}`;
    
                        // Save the file
                        saveAs(blob, fileName);
                    }
                })
                .catch((error) => console.log(error))
                .finally(() => dispatch(unsetLoading()));
        };
    return (
        <>
            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("COUNRSE_OF_STUDT.SEARCH_COURSE")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setKeyword(e.target.value)
                        }}
                        value={keyword || ''}
                    />
                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <FilterSelect
                        value={study_day || ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={days.map((item: any, index: number) => (
                            <MenuItem value={index} key={index + 1}>
                                {t(item)}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("year", e.target.value)
                            set_study_day(e.target.value)
                        }}
                    />

                </article>

                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    <FilterSelect
                        value={room || ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={['ทุกห้อง', ...[detail?.room ? detail?.room?.split(',') : []]]?.map((x: any, index: number) => ( // i18n-ignore: room filter sentinel value, rendered with t
                            <MenuItem value={x} key={index + 1}>
                                {index === 0 ? t(x) : x}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setRoom(e.target.value)
                        }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    />

                </article>


                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-5 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                        gap: '10px'
                    }}
                >
                    {/* <ContainerButton
                        justifyContent='flex-end'
                        sxContainer={{width:'fit-content'}}
                        buttonData={[

                            {
                                buttonProps: {
                                    onClick: () => {
                                        // setShowModal('ADD')
                                        handleDownloadFile()
                                    }
                                },
                                key: "DOWNLOAD_PDF",
                                label: t("TERM_PAYMENT_DOWNLOAD_PDF"),
                                seq: 3,
                                type: 'DOWNLOAD_PDF'
                            },

                        ]}
                    /> */}

                    <ButtonPrimary
                        onClick={() => {
                            // navigate(routeName.cms.ManageLeaveType + `/create`);
                            if (course_annual_file) {
                                getFile(course_annual_file?.id_course_annual_file)
                                setType('')
                            } else {
                                setType('NEW')
                            }
                            setOpen(true)

                        }}
                        mode="add"
                        buttonName={status_publish !== 'PUBLISH' ? t("COUNRSE_OF_STUDT.PUBLISH") : t("COUNRSE_OF_STUDT.UNPUBLISH")}
                        btnProps={{ bg: '#245B8E' }}
                    />

                    <ButtonPrimary
                        onClick={() => {
                            // navigate(routeName.cms.ManageLeaveType + `/create`);
                            handleDownloadFile()
                        }}
                        mode="add"
                        buttonName={t("COUNRSE_OF_STUDT.DOWNLOAD_SCHEDULE")}
                        btnProps={{ bg: '#2186E3' }}
                    />
                    <ButtonPrimary
                        onClick={() => {
                            navigate(routeName.cms.CourseOfStudyAddSubject.replace(':id', id || '') + '?academic_year=' + academic_year + `&term=${term}`);
                        }}
                        mode="add"
                        buttonName={t("COUNRSE_OF_STUDT.ADD_COURSE")}
                    />
                </article>
            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data?.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
            <ModalCustom title={status_publish !== 'PUBLISH' ? t("COUNRSE_OF_STUDT.PUBLISH") : t("COUNRSE_OF_STUDT.PUBLISH")} subTitle={t('กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน')} open={open} component={
                <div className='flex flex-col gap-4' style={{ position: 'relative' }}>
                    {type === 'NEW' ? <>{file ? <><img src={URL.createObjectURL(file)} style={{
                        width: '100%', height: '400px', objectFit: "contain"
                    }} />
                        <IconButton onClick={() => {
                            setType('NEW')
                            setFile(null)
                        }} style={{ position: 'absolute', top: '10px', right: "10px" }} ><CloseIcon /></IconButton>
                    </> : <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: "center", width: '100%', height: '400px', background: "#F2F4F7", borderRadius: '10px' }}>
                        <Icon_upload onClick={() => handleImageUploadClick()} />
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept={'image/*'}
                            style={{ display: "none" }}
                            onChange={updateImage}
                        />

                    </Box>}</> : <>
                        <img src={`${pathUrl}`} style={{
                            width: '100%', height: '400px', objectFit: "contain"
                        }} />
                        <IconButton onClick={() => setType('NEW')} style={{ position: 'absolute', top: '10px', right: "10px" }} ><CloseIcon /></IconButton>
                    </>}
                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleClose()
                            }}
                            buttonName={t('ยกเลิก')}
                        />
                        <ButtonPrimary
                            onClick={() => handleUpdateStatus('PUBLISH')}
                            mode='add'
                            buttonName={t('ยืนยัน')}
                            disabled={!file}
                        />
                    </div>
                </div>
            } />
        </>
    )
}
